import { IOperationPlan, IKPIData } from '../types/operations.types'

export const MOCK_KPIS: IKPIData = {
  runningTasks: 24,
  blockedTasks: 3,
  inQueue: 47,
  activeWorkers: 86,
  activeMachines: 18,
}

export const MOCK_PLANS: IOperationPlan[] = [
  {
    id: 'plan-001',
    name: 'Ore Haulage - Pit B to Crusher',
    siteId: 1,
    siteName: 'Site Alpha',
    departmentId: 1,
    departmentName: 'Operations',
    locationScope: [1, 2],
    priority: 'High',
    targetMetricType: 'Tons',
    targetValue: 240,
    targetUnit: 't/h',
    currentValue: 212,
    status: 'Active',
    progress: 68,
    queueHealth: 'Stable',
    workers: 12,
    machines: 6,
    activeCycles: 4,
    estCompletion: '2026-04-15',
    createdAt: '2026-03-01T08:00:00Z',
    source: 'PLAN',
    sourceId: 'plan-001',
    generatedAt: '2026-03-01T08:00:00Z',
  },
  {
    id: 'plan-002',
    name: 'Excavation - Zone B North',
    siteId: 1,
    siteName: 'Site Alpha',
    departmentId: 2,
    departmentName: 'Mining',
    locationScope: [3],
    priority: 'Critical',
    targetMetricType: 'Square Meters',
    targetValue: 1000,
    targetUnit: 'm²',
    currentValue: 320,
    status: 'Active',
    progress: 32,
    queueHealth: 'At Risk',
    workers: 8,
    machines: 3,
    activeCycles: 2,
    estCompletion: '2026-05-01',
    createdAt: '2026-03-05T08:00:00Z',
    source: 'PLAN',
    sourceId: 'plan-002',
    generatedAt: '2026-03-05T08:00:00Z',
  },
  {
    id: 'plan-003',
    name: 'TSF Construction - Cell 2',
    siteId: 2,
    siteName: 'Site Beta',
    departmentId: 3,
    departmentName: 'Construction',
    locationScope: [4, 5],
    priority: 'Medium',
    targetMetricType: 'Count',
    targetValue: 100,
    targetUnit: '%',
    currentValue: 45,
    status: 'Active',
    progress: 45,
    queueHealth: 'Healthy',
    workers: 15,
    machines: 4,
    activeCycles: 3,
    createdAt: '2026-02-15T08:00:00Z',
    source: 'PLAN',
    sourceId: 'plan-003',
    generatedAt: '2026-02-15T08:00:00Z',
  },
  {
    id: 'plan-004',
    name: 'Road Maintenance - Main Haul',
    siteId: 1,
    siteName: 'Site Alpha',
    departmentId: 4,
    departmentName: 'Maintenance',
    locationScope: [6],
    priority: 'Low',
    targetMetricType: 'Kilometers',
    targetValue: 5,
    targetUnit: 'km',
    currentValue: 0,
    status: 'Paused',
    progress: 60,
    queueHealth: 'Paused',
    workers: 6,
    machines: 2,
    activeCycles: 0,
    createdAt: '2026-03-10T08:00:00Z',
    source: 'PLAN',
    sourceId: 'plan-004',
    generatedAt: '2026-03-10T08:00:00Z',
  },
]
